import type React from 'react';
import { createContainer, createHook, createStore } from '@atlassian/react-sweet-state';
import { STORE_NAME } from '../../common/constants.tsx';
import type { State } from '../../common/types.tsx';
import { actions } from './actions.tsx';

export const SidebarContainer = createContainer();

const Store = createStore<State, typeof actions>({
	containedBy: SidebarContainer,
	initialState: {
		id: null,
		content: null,
	},
	actions,
	name: STORE_NAME,
});

const useHook = createHook(Store);

type SidebarActions = {
	setSidebarContent: (id: string, content: React.ReactElement | null) => void;
	closeSidebar: () => void;
};

export const useSidebar = (): [State, SidebarActions] => {
	return useHook();
};
